<template>
  <SocialIcon :icon="icon" :link="generateLink(id)"/>
</template>

<script setup>
import SocialIcon from "@/components/social/components/SocialIcon.vue";
import icon from "@/components/social/assets/telegram.svg";

defineProps({
  id: String, // Telegram nickname
});

const generateLink = (id) => `https://t.me/${id}`;
</script>

<style scoped>

</style>